<div class="dialog">
  <h2>{{ data.title }}</h2>
  <mat-dialog-content>
    <ng-container [ngComponentOutlet]="data.dialogContent"> </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button
      mat-flat-button
      color="primary"
      class="blue-outline-button"
      (click)="onNoClick()"
    >
      CLOSE
    </button>
  </mat-dialog-actions>
</div>

